import { translate } from "../translate/translate";

const translations: Record<string, { separator: string }> = {
  "en": { separator: ":" },
  "pt": { separator: "h" },
};

const formatDateTime = (dateString: string | null, language = translate.language): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString(language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const formattedTime = date
    .toLocaleTimeString(language, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(":", translations[language]?.separator || ":");

  return `${formattedDate} - ${formattedTime}`;
};

const formatDate = (dateValue: string, language = translate.language): string => {
  if (!dateValue) return "N/A";

  const date = new Date(dateValue);
  const formattedDate = date.toLocaleDateString(language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
};

export const getNextWeeksWeekday = (currentDate: Date, weekday = 5): Date => {
  const currentDay = currentDate.getDay();
  const resultDate = new Date(currentDate);

  let delta = weekday - currentDay;

  if (delta <= 0) {
    delta += 7;
  }

  resultDate.setDate(currentDate.getDate() + delta);

  resultDate.setHours(23);
  resultDate.setMinutes(59);
  resultDate.setSeconds(59);
  resultDate.setMilliseconds(999);

  return resultDate;
};

export const formatter = {
  formatDate,
  formatDateTime,
};
